module.exports = __webpack_public_path__ + "79d3fc94f67c60ab0e38f2e3511b9985.png";